/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
  DatePicker,
  Tabs,
  Tooltip,
} from 'antd';
import { QuestionCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { formatReceivedValues } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import currencyFormatter from 'utils/currencyFormatter';
import CurrencyInput from 'components/CurrencyInput';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import makeMessager from 'utils/complexFormsMessages';
import { getModelPermission } from 'utils/permission';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  getTabuladoresGenerales,
  postTabuladorGeneral,
  deleteTabuladorGeneral,
  patchTabuladorGeneral,
  getTabuladorGeneral,
} from 'api/nominas/tabuladores/tabuladoresGenerales';
import {
  getPuestos,
} from 'api/estructuraOrganizacional/puestos';
import {
  getNivelesSalarialesTabulares,
} from 'api/nominas/catalogos/nivelesSalarialesTabulares';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
  FLOAT_NUMER_PATTERN,
} from 'utils/patterns';
import { getCategoriasDePuestos } from 'api/catalogos/categoriaDePuestos';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import TabuladorGeneralDeduccion, { tabuladorGeneralDeduccionPermission } from './TabuladoreGeneralesDeducciones';
import TabuladorGeneralPercepcion, { tabuladorGeneralPercepcionPermission } from './TabuladoresGeneralesPercepciones';
import {
  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
} from '../../../utils/constants';

const { TabPane } = Tabs;

export const tabuladorGeneralPermission = {
  permissionModel: 'tabuladorgeneral',
  catalogsModels: [],
  tabsModels: [],
};

const complexForms = [];
const baseURI = 'nominas/tabuladores-generales';

const TabuladorGeneral = ({ permission }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [estados, setEstados] = useState([]);
  const [niveles, setNiveles] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('percepciones');
  const [mutable, setMutable] = useState(true);
  const [categoriasDePuestos, setCategoriasDePuestos] = useState([]);
  const [categoriaDePuesto, setCategoriaDePuesto] = useState();
  const [tiposDeEmpleados, setTiposDeEmpleados] = useState([]);
  const [tipoDeEmpleado, setTipoDeEmpleado] = useState();
  const [sueldoMensualDesde, setSueldoMensualDesde] = useState();
  const [sueldoMensualHasta, setSueldoMensualHasta] = useState();
  const [puestosFiltered, setPuestosFiltered] = useState();
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [disableSave, setDisableSave] = useState(false);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        puesto_categoria: e?.puesto,
        puesto_tipoEmpleado: e?.puesto,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const basicKeys = [
    'percepciones',
    'deducciones',
  ];

  const formInstances = [
    form,
    formDatos,
  ];

  const getPermissionDeduccion = getModelPermission(
    tabuladorGeneralDeduccionPermission.permissionModel,
    tabuladorGeneralDeduccionPermission.catalogsModels,
    tabuladorGeneralDeduccionPermission.tabsModels,
    false,
  );

  const getPermissionPercepcion = getModelPermission(
    tabuladorGeneralPercepcionPermission.permissionModel,
    tabuladorGeneralPercepcionPermission.catalogsModels,
    tabuladorGeneralPercepcionPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    setLoading(true);
    const _data = await getTabuladoresGenerales();
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _puestos,
        _niveles,
        _categorias,
        _tiposEmpleados,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPuestos({ estados_globales: ESTATUS_AUTORIZADO }),
        getNivelesSalarialesTabulares({ estados_globales: ESTATUS_AUTORIZADO }),
        getCategoriasDePuestos(),
        getTiposDeEmpleados(),
        getTabuladoresGenerales(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setPuestos(_puestos);
        setNiveles(_niveles);
        setCategoriasDePuestos(_categorias);
        setTiposDeEmpleados(_tiposEmpleados);
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setDisableSave(false);
    setSelectedRowKeys([]);
    setVisible(false);
    setMutable(true);
    setCategoriaDePuesto();
    setTipoDeEmpleado();
    setSueldoMensualDesde();
    setSueldoMensualHasta();
    setPuestosFiltered(
      puestos.filter((e) => !data.some((val) => e.id === val.puesto)),
    );
    form.resetFields();
    formDatos.resetFields();
  };

  const onChangePuesto = () => {
    const _puesto = form.getFieldValue('puesto');
    const _categoria = puestos.find((e) => e.id === _puesto)?.categoria;
    const _tipoEmpleado = puestos.find((e) => e.id === _puesto)?.tipo_empleado;
    setCategoriaDePuesto(categoriasDePuestos.find((e) => e.id === _categoria)?.nombre);
    setTipoDeEmpleado(tiposDeEmpleados.find((e) => e.id === _tipoEmpleado)?.descripcion);
    form.setFieldValue('categoria', categoriasDePuestos.find((e) => e.id === _categoria)?.nombre);
    form.setFieldValue('tipo_de_empleado', tiposDeEmpleados.find((e) => e.id === _tipoEmpleado)?.descripcion);
  };

  const isDisabled = (rowEstatus) => {
    if (rowEstatus !== ESTATUS_ACTIVO) {
      setDisableSave(true);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _tabulador = await getTabuladorGeneral(match.id);
    const _sueldoDiarioDesde = form.getFieldValue('sueldo_diario_desde');
    const _sueldoDiarioHasta = form.getFieldValue('sueldo_diario_hasta');
    setSueldoMensualDesde((_sueldoDiarioDesde * 30).toFixed(2) || 0);
    setSueldoMensualHasta((_sueldoDiarioHasta * 30).toFixed(2) || 0);
    onChangePuesto();
    if (_tabulador?.estados_globales === ESTATUS_ACTIVO || _tabulador?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO || estado?.id === ESTATUS_ACTIVO));
    }
    if (_tabulador.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    if (_tabulador?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    setTimeout(() => {
      if (_tabulador) {
        form.resetFields();
        formDatos.resetFields();
        setTimeout(() => {
          isDisabled(_tabulador?.estados_globales);
          form.setFieldsValue(formatReceivedClone(_tabulador));
          formDatos.setFieldsValue(formatReceivedClone(_tabulador));
          setPuestosFiltered(
            puestos.filter((e) => !data.some((val) => {
              if (val.puesto === _tabulador.puesto) {
                return false;
              }
              return val.puesto === e.id;
            })),
          );
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchTabuladorGeneral(key, values) : postTabuladorGeneral(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteTabuladorGeneral(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Tabulador General',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      width: 200,
      render: (val) => puestos.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Categoría',
      dataIndex: 'puesto_categoria',
      key: 'puesto_categoria',
      width: 200,
      render: (val) => {
        const _categoria = puestos.find((e) => e.id === val)?.categoria;
        return categoriasDePuestos.find((e) => e.id === _categoria)?.nombre;
      },
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'puesto_tipoEmpleado',
      key: 'puesto_tipoEmpleado',
      width: 200,
      render: (val) => {
        const _tipoEmpleado = puestos.find((e) => e.id === val)?.tipo_empleado;
        return tiposDeEmpleados.find((e) => e.id === _tipoEmpleado)?.descripcion;
      },
    },
    {
      titleText: 'Desde Sueldo Mensual Tabular',
      dataIndex: 'sueldo_diario_desde',
      key: 'sueldo_diario_desde',
      width: 250,
      align: 'right',
      render: (val) => currencyFormatter(val * 30 || 0),
    },
    {
      titleText: 'Hasta Sueldo Mensual Tabular',
      dataIndex: 'sueldo_diario_hasta',
      key: 'sueldo_diario_hasta',
      width: 250,
      align: 'right',
      render: (val) => currencyFormatter(val * 30 || 0),
    },
    {
      titleText: 'Nivel Salarial Tabular',
      dataIndex: 'nivel_salarial_tabular',
      key: 'nivel_salarial_tabular',
      width: 250,
      render: (val) => {
        const _nivelSalarialTabular = niveles.find((e) => e.id === val);
        return _nivelSalarialTabular ? `${_nivelSalarialTabular?.clave} - ${currencyFormatter(_nivelSalarialTabular?.sueldo_diario)}` : '';
      },
    },
    {
      titleText: 'Vigencia Inicial',
      dataIndex: 'vigencia_inicial',
      key: 'vigencia_inicial',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const showMsg = makeMessager(setCurrentTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valorDesde: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async (_, value) => {
          const { sueldo_diario_hasta } = form.getFieldsValue();
          if (sueldo_diario_hasta && value >= sueldo_diario_hasta) {
            throw new Error('Desde Sueldo Diario Tabular no puede ser mayor o igual a Hasta Sueldo Diario Tabular');
          }
        },
      },
    ],
    valorHasta: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async (_, value) => {
          const { sueldo_diario_desde } = form.getFieldsValue();
          if (sueldo_diario_desde && value <= sueldo_diario_desde) {
            throw new Error('Hasta Sueldo Diario Tabular no puede ser menor o igual a Desde Sueldo Diario Tabular');
          }
        },
      },
    ],
    vigencia_inicial: [
      { required: true },
      {
        validator: async () => {
          const { vigencia_inicial, vigencia_final } = form.getFieldsValue();
          if (vigencia_inicial && vigencia_final
            && vigencia_inicial.diff(vigencia_final, 'days') >= 0) {
            throw new Error('Este campo debe ser menor que la Vigencia Final');
          }
        },
      },
    ],
    vigencia_final: [
      { required: false },
      {
        validator: async () => {
          const { vigencia_inicial, vigencia_final } = form.getFieldsValue();
          if (vigencia_inicial && vigencia_final
            && vigencia_final.diff(vigencia_inicial, 'days') <= 0) {
            throw new Error('Este campo debe ser mayor que la Vigencia Inicial');
          }
        },
      },
    ],
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchTabuladorGeneral(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            allowImport
            baseURI={baseURI}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
            }
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'tabuladorgeneral', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
            ]}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Tabulador General`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableSave}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave"
                    rules={rules.clave}
                    label="Clave"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="nombre"
                    rules={rules.required}
                    label={(
                      <div style={{ style: 'flex' }}>
                        <span>Tabulador General</span>
                        <Tooltip title="Asignar un nombre al Tabulador General para identificarlo, se sugiere el nombre del Puesto">
                          <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                        </Tooltip>
                      </div>
                    )}
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="puesto"
                    label="Puesto"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={puestosFiltered}
                      onChange={onChangePuesto}
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="categoria"
                    label="Categoría"
                  >
                    <Input
                      disabled
                      defaultValue={categoriaDePuesto}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_empleado"
                    label="Tipo de Empleado"
                  >
                    <Input
                      disabled
                      defaultValue={tipoDeEmpleado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="nivel_salarial_tabular"
                    label="Nivel Salarial Tabular"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      labelProp="clave"
                      keyProp="id"
                      dataSource={niveles}
                      render={(val) => `${val?.clave} - ${currencyFormatter(val?.sueldo_diario)}`}
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="sueldo_diario_desde"
                    label="Desde Sueldo Diario Tabular"
                    rules={rules.valorDesde}
                    onChange={(value) => {
                      form.setFieldsValue({
                        sueldo_mensual_desde: (value * 30).toFixed(2),
                      });
                    }}
                    disabled={estatusInactivo || estatusAutorizado}
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="sueldo_diario_hasta"
                    label="Hasta Sueldo Diario Tabular"
                    rules={rules.valorHasta}
                    onChange={(value) => {
                      form.setFieldsValue({
                        sueldo_mensual_hasta: (value * 30).toFixed(2),
                      });
                    }}
                    disabled={estatusInactivo || estatusAutorizado}
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="sueldo_mensual_desde"
                    label="Desde Sueldo Mensual Tabular"
                    disabled
                    defaultValue={sueldoMensualDesde}
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="sueldo_mensual_hasta"
                    label="Hasta Sueldo Mensual Tabular"
                    disabled
                    defaultValue={sueldoMensualHasta}
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigencia_inicial"
                    label="Vigencia Inicial"
                    rules={rules.vigencia_inicial}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigencia_final"
                    label="Vigencia Final"
                    rules={rules.vigencia_final}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estadosFiltered}
                      disabled={!selectedRowKeys.length || estatusInactivo || estatusAutorizado}
                      onChange={(val) => {
                        if (val === ESTATUS_INACTIVO) {
                          setConfirmationVisibleEstatus(true);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {
                selectedRowKeys.length
                  ? (
                    <Tabs
                      activeKey={currentTabKey}
                      onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                      type="card"
                    >
                      <TabPane
                        tab="Percepciones"
                        key="percepciones"
                        forceRender
                      >
                        <TabuladorGeneralPercepcion
                          permission={getPermissionPercepcion}
                          selected={selectedRowKeys[0]}
                          estatusInactivo={estatusInactivo || estatusAutorizado}
                        />
                      </TabPane>
                      <TabPane
                        tab="Deducciones"
                        key="deducciones"
                        forceRender
                      >
                        <TabuladorGeneralDeduccion
                          permission={getPermissionDeduccion}
                          selected={selectedRowKeys[0]}
                          estatusInactivo={estatusInactivo || estatusAutorizado}
                        />
                      </TabPane>
                    </Tabs>
                  ) : null
              }
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Tabulador General ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Tabulador General ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          ConfirmInactive
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          contentTitle={`Inactivar el Tabulador General ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default TabuladorGeneral;
